<script lang="ts">
  import { GenerateKey } from "$ui/generate-key";
  import { PasteKey } from "$ui/paste-key";
  import { getTeamAppKeys } from "$stores/teamAppKeys";

  export let teamId = "";
  export let appId = "";
  export let hideGenerateKey = false;

  const keys = getTeamAppKeys(teamId, appId);
</script>

<div class="flex flex-col gap-4">
  {#if !hideGenerateKey}
    <div>
      <h3 class="font-semibold">Generate API key</h3>
      <p>This is the only time that this API Key can be viewed or downloaded. You can create more keys later.</p>
    </div>
    <GenerateKey {appId} />
    {#if $keys === undefined}
      <div class="text-sm -mt-2">Loading</div>
    {:else if $keys?.length > 1}
      <div class="text-sm text-danger-700 -mt-2">
        This app has the maximum of 2 API keys already, please remove one to generate another
      </div>
    {/if}
  {:else}
    <PasteKey {appId} />
  {/if}
</div>
